var Afghanistan = "阿富汗";
var Albania = "阿尔巴尼亚";
var Algeria = "阿尔及利亚";
var Andorra = "安道尔";
var Angola = "安哥拉";
var Anguilla = "安圭拉岛";
var Antarctica = "南极洲";
var Argentina = "阿根廷";
var Armenia = "亚美尼亚";
var Aruba = "阿鲁巴岛";
var Australia = "澳大利亚";
var Austria = "奥地利";
var Azerbaijan = "阿塞拜疆";
var Bahamas = "巴哈马";
var Bahrain = "巴林";
var Bangladesh = "孟加拉国";
var Barbados = "巴巴多斯";
var Belarus = "白俄罗斯";
var Belgium = "比利时";
var Belize = "伯利兹";
var Benin = "贝宁";
var Bermuda = "百慕大";
var Bhutan = "不丹";
var Bolivia = "玻利维亚";
var Botswana = "博茨瓦纳";
var Brazil = "巴西";
var Bulgaria = "保加利亚";
var Burundi = "布隆迪";
var Cambodia = "柬埔寨";
var Cameroon = "喀麦隆";
var Canada = "加拿大";
var Chad = "乍得";
var Chile = "智利";
var China = "中国";
var Colombia = "哥伦比亚";
var Comoros = "科摩罗";
var Congo = "刚果";
var Croatia = "克罗地亚";
var Cuba = "古巴";
var Cyprus = "塞浦路斯";
var Denmark = "丹麦";
var Djibouti = "吉布提";
var Dominica = "多米尼加";
var Ecuador = "厄瓜多尔";
var Egypt = "埃及";
var Eritrea = "厄立特里亚";
var Estonia = "爱沙尼亚";
var Ethiopia = "埃塞俄比亚";
var Fiji = "斐济";
var Finland = "芬兰";
var France = "法国";
var Gabon = "加蓬";
var Gambia = "冈比亚";
var Georgia = "格鲁吉亚";
var Germany = "德国";
var Ghana = "加纳";
var Gibraltar = "直布罗陀";
var Greece = "希腊";
var Greenland = "格陵兰";
var Grenada = "格林纳达";
var Guadeloupe = "瓜德罗普岛";
var Guam = "关岛";
var Guatemala = "危地马拉";
var Guernsey = "根西岛";
var Guinea = "几内亚";
var Guyana = "圭亚那";
var Haiti = "海地";
var Honduras = "洪都拉斯";
var Hungary = "匈牙利";
var Iceland = "冰岛";
var India = "印度";
var Indonesia = "印度尼西亚";
var Iraq = "伊拉克";
var Ireland = "爱尔兰";
var Israel = "以色列";
var Italy = "意大利";
var Jamaica = "牙买加";
var Japan = "日本";
var Jersey = "泽西岛";
var Jordan = "约旦";
var Kazakhstan = "哈萨克";
var Kenya = "肯尼亚";
var Kiribati = "基里巴斯";
var Kuwait = "科威特";
var Kyrgyzstan = "吉尔吉斯斯坦";
var Latvia = "拉脱维亚";
var Lebanon = "黎巴嫩";
var Lesotho = "莱索托";
var Liberia = "利比里亚";
var Libya = "阿拉伯利比亚民众国";
var Liechtenstein = "列支敦士登";
var Lithuania = "立陶宛";
var Luxembourg = "卢森堡";
var Macao = "澳门";
var Madagascar = "马达加斯加";
var Malawi = "马拉维";
var Malaysia = "马来西亚";
var Maldives = "马尔代夫";
var Mali = "马里";
var Malta = "马耳他";
var Martinique = "马提尼克";
var Mauritania = "毛里塔尼亚";
var Mauritius = "毛里求斯";
var Mayotte = "马约特岛";
var Mexico = "墨西哥";
var Monaco = "摩纳哥";
var Mongolia = "蒙古";
var Montenegro = "黑山共和国";
var Montserrat = "蒙特塞拉特岛";
var Morocco = "摩洛哥";
var Mozambique = "莫桑比克";
var Myanmar = "缅甸";
var Namibia = "纳米比亚";
var Nauru = "瑙鲁";
var Nepal = "尼泊尔";
var Netherlands = "荷兰";
var Nicaragua = "尼加拉瓜";
var Niger = "尼日尔";
var Nigeria = "尼日利亚";
var Niue = "纽埃岛";
var Norway = "挪威";
var Oman = "阿曼";
var Pakistan = "巴基斯坦";
var Palau = "帕劳群岛";
var Panama = "巴拿马";
var Paraguay = "巴拉圭";
var Peru = "秘鲁";
var Philippines = "菲律宾";
var Pitcairn = "皮特克恩";
var Poland = "波兰";
var Portugal = "葡萄牙";
var Qatar = "卡塔尔";
var Romania = "罗马尼亚";
var Rwanda = "卢旺达";
var Samoa = "萨摩亚群岛";
var Senegal = "塞内加尔";
var Serbia = "塞尔维亚";
var Seychelles = "塞舌尔";
var Singapore = "新加坡";
var Slovakia = "斯洛伐克";
var Slovenia = "斯洛文尼亚";
var Somalia = "索马里";
var Spain = "西班牙";
var Sudan = "苏丹";
var Suriname = "苏里南";
var Swaziland = "斯威士兰";
var Sweden = "瑞典";
var Switzerland = "瑞士";
var Taiwan = "台湾";
var Tajikistan = "塔吉克斯坦";
var Thailand = "泰国";
var Togo = "多哥";
var Tokelau = "托克劳群岛";
var Tonga = "汤加";
var Tunisia = "突尼斯";
var Turkey = "土耳其";
var Turkmenistan = "土库曼斯坦";
var Tuvalu = "图瓦卢";
var Uganda = "乌干达";
var Ukraine = "乌克兰";
var Uruguay = "乌拉圭";
var Uzbekistan = "乌兹别克斯坦";
var Vanuatu = "瓦努阿图";
var Venezuela = "委内瑞拉";
var Yemen = "也门";
var Zambia = "赞比亚";
var Zimbabwe = "津巴布韦";
var countries = {
	"Country or region": "国家或地区",
	"United States": "美国",
	Afghanistan: Afghanistan,
	"Åland Islands": "奥兰群岛",
	Albania: Albania,
	Algeria: Algeria,
	"American Samoa": "美属萨摩亚",
	Andorra: Andorra,
	Angola: Angola,
	Anguilla: Anguilla,
	Antarctica: Antarctica,
	"Antigua and Barbuda": "安提瓜和巴布达",
	Argentina: Argentina,
	Armenia: Armenia,
	Aruba: Aruba,
	Australia: Australia,
	Austria: Austria,
	Azerbaijan: Azerbaijan,
	Bahamas: Bahamas,
	Bahrain: Bahrain,
	Bangladesh: Bangladesh,
	Barbados: Barbados,
	Belarus: Belarus,
	Belgium: Belgium,
	Belize: Belize,
	Benin: Benin,
	Bermuda: Bermuda,
	Bhutan: Bhutan,
	Bolivia: Bolivia,
	"Bosnia and Herzegovina": "波斯尼亚和黑塞哥维那",
	Botswana: Botswana,
	"Bouvet Island": "布维岛",
	Brazil: Brazil,
	"British Indian Ocean Territory": "英属印度洋领地",
	"Brunei Darussalam": "文莱达鲁萨兰国",
	Bulgaria: Bulgaria,
	"Burkina Faso": "布基纳法索",
	Burundi: Burundi,
	Cambodia: Cambodia,
	Cameroon: Cameroon,
	Canada: Canada,
	"Cape Verde": "佛得角",
	"Cayman Islands": "开曼群岛",
	"Central African Republic": "中非共和国",
	Chad: Chad,
	Chile: Chile,
	China: China,
	"Christmas Island": "圣诞岛",
	"Cocos (Keeling) Islands": "科科斯群岛",
	Colombia: Colombia,
	Comoros: Comoros,
	Congo: Congo,
	"Congo, The Democratic Republic of The": "刚果民主共和国",
	"Cook Islands": "库克群岛",
	"Costa Rica": "哥斯达黎加",
	"Côte d'Ivoire": "科特迪瓦",
	Croatia: Croatia,
	Cuba: Cuba,
	Cyprus: Cyprus,
	"Czech Republic": "捷克共和国",
	Denmark: Denmark,
	Djibouti: Djibouti,
	Dominica: Dominica,
	"Dominican Republic": "多米尼加共和国",
	Ecuador: Ecuador,
	Egypt: Egypt,
	"El Salvador": "萨尔瓦多",
	"Equatorial Guinea": "赤道几内亚",
	Eritrea: Eritrea,
	Estonia: Estonia,
	Ethiopia: Ethiopia,
	"Falkland Islands (Malvinas)": "福克兰群岛（马尔维纳斯）",
	"Faroe Islands": "法罗群岛",
	Fiji: Fiji,
	Finland: Finland,
	France: France,
	"French Guiana": "法属圭亚那",
	"French Polynesia": "法属玻里尼西亚",
	"French Southern Territories": "法属南部属地",
	Gabon: Gabon,
	Gambia: Gambia,
	Georgia: Georgia,
	Germany: Germany,
	Ghana: Ghana,
	Gibraltar: Gibraltar,
	Greece: Greece,
	Greenland: Greenland,
	Grenada: Grenada,
	Guadeloupe: Guadeloupe,
	Guam: Guam,
	Guatemala: Guatemala,
	Guernsey: Guernsey,
	Guinea: Guinea,
	"Guinea-Bissau": "几内亚比绍",
	Guyana: Guyana,
	Haiti: Haiti,
	"Heard Island and McDonald Islands": "赫德岛和麦克唐纳群岛",
	"Holy See (Vatican City State)": "罗马教廷（梵蒂冈城国）",
	Honduras: Honduras,
	"Hong Kong": "中国香港特别行政区",
	Hungary: Hungary,
	Iceland: Iceland,
	India: India,
	Indonesia: Indonesia,
	"Iran, Islamic Republic of": "伊朗伊斯兰共和国",
	Iraq: Iraq,
	Ireland: Ireland,
	"Isle of Man": "马恩岛",
	Israel: Israel,
	Italy: Italy,
	Jamaica: Jamaica,
	Japan: Japan,
	Jersey: Jersey,
	Jordan: Jordan,
	Kazakhstan: Kazakhstan,
	Kenya: Kenya,
	Kiribati: Kiribati,
	"Korea, Democratic People’s Republic of": "朝鲜民主主义人民共和国",
	"Korea, Republic of": "大韩民国",
	Kuwait: Kuwait,
	Kyrgyzstan: Kyrgyzstan,
	"Lao People's Democratic Republic": "老挝人民民主共和国",
	Latvia: Latvia,
	Lebanon: Lebanon,
	Lesotho: Lesotho,
	Liberia: Liberia,
	Libya: Libya,
	Liechtenstein: Liechtenstein,
	Lithuania: Lithuania,
	Luxembourg: Luxembourg,
	Macao: Macao,
	"Macedonia, The Former Yugoslav Republic of": "马其顿，前南斯拉夫共和国",
	Madagascar: Madagascar,
	Malawi: Malawi,
	Malaysia: Malaysia,
	Maldives: Maldives,
	Mali: Mali,
	Malta: Malta,
	"Marshall Islands": "马绍尔群岛",
	Martinique: Martinique,
	Mauritania: Mauritania,
	Mauritius: Mauritius,
	Mayotte: Mayotte,
	Mexico: Mexico,
	"Micronesia, Federated States of": "密克罗尼西亚联邦",
	"Moldova, Republic of": "摩尔多瓦共和国",
	Monaco: Monaco,
	Mongolia: Mongolia,
	Montenegro: Montenegro,
	Montserrat: Montserrat,
	Morocco: Morocco,
	Mozambique: Mozambique,
	Myanmar: Myanmar,
	Namibia: Namibia,
	Nauru: Nauru,
	Nepal: Nepal,
	Netherlands: Netherlands,
	"Netherlands Antilles": "荷属安的列斯",
	"New Caledonia": "新喀里多尼亚",
	"New Zealand": "新西兰",
	Nicaragua: Nicaragua,
	Niger: Niger,
	Nigeria: Nigeria,
	Niue: Niue,
	"Norfolk Island": "诺福克岛",
	"Northern Mariana Islands": "北马里亚纳群岛",
	Norway: Norway,
	Oman: Oman,
	Pakistan: Pakistan,
	Palau: Palau,
	"Palestine, State of": "巴勒斯坦被占领土",
	Panama: Panama,
	"Papua New Guinea": "巴布亚新几内亚",
	Paraguay: Paraguay,
	Peru: Peru,
	Philippines: Philippines,
	Pitcairn: Pitcairn,
	Poland: Poland,
	Portugal: Portugal,
	"Puerto Rico": "波多黎各",
	Qatar: Qatar,
	"Réunion": "留尼汪岛",
	Romania: Romania,
	"Russian Federation": "俄罗斯联邦",
	Rwanda: Rwanda,
	"Saint Helena": "圣赫勒拿岛",
	"Saint Kitts and Nevis": "圣基茨和尼维斯",
	"Saint Lucia": "圣卢西亚岛",
	"Saint Pierre and Miquelon": "圣皮埃尔岛和密克隆岛",
	"Saint Vincent and The Grenadines": "圣文森特和格林纳丁斯",
	Samoa: Samoa,
	"San Marino": "圣马力诺",
	"Sao Tome and Principe": "圣多美与普林希比共和国",
	"Saudi Arabia": "沙特阿拉伯",
	Senegal: Senegal,
	Serbia: Serbia,
	Seychelles: Seychelles,
	"Sierra Leone": "塞拉利昂",
	Singapore: Singapore,
	Slovakia: Slovakia,
	Slovenia: Slovenia,
	"Solomon Islands": "所罗门群岛",
	Somalia: Somalia,
	"South Africa": "南非",
	"South Georgia and The South Sandwich Islands": "南乔治亚岛和南桑威奇群岛",
	Spain: Spain,
	"Sri Lanka": "斯里兰卡",
	Sudan: Sudan,
	Suriname: Suriname,
	"Svalbard and Jan Mayen": "斯瓦尔巴群岛和扬马延",
	Swaziland: Swaziland,
	Sweden: Sweden,
	Switzerland: Switzerland,
	"Syrian Arab Republic": "阿拉伯叙利亚共和国",
	Taiwan: Taiwan,
	Tajikistan: Tajikistan,
	"Tanzania, United Republic of": "坦桑尼亚联合共和国",
	Thailand: Thailand,
	"Timor-Leste": "东帝汶",
	Togo: Togo,
	Tokelau: Tokelau,
	Tonga: Tonga,
	"Trinidad and Tobago": "特立尼达和多巴哥",
	Tunisia: Tunisia,
	Turkey: Turkey,
	Turkmenistan: Turkmenistan,
	"Turks and Caicos Islands": "特克斯和凯科斯群岛",
	Tuvalu: Tuvalu,
	Uganda: Uganda,
	Ukraine: Ukraine,
	"United Arab Emirates": "阿拉伯联合酋长国",
	"United Kingdom": "英国",
	"United States Minor Outlying Islands": "美国本土外小岛屿",
	Uruguay: Uruguay,
	Uzbekistan: Uzbekistan,
	Vanuatu: Vanuatu,
	Venezuela: Venezuela,
	"Viet Nam": "越南",
	"Virgin Islands, British": "英属维尔京群岛",
	"Virgin Islands, U.S.": "美属维尔京群岛",
	"Wallis and Futuna": "瓦利斯和富图纳群岛",
	"Western Sahara": "西撒哈拉",
	Yemen: Yemen,
	Zambia: Zambia,
	Zimbabwe: Zimbabwe
};

export { Afghanistan, Albania, Algeria, Andorra, Angola, Anguilla, Antarctica, Argentina, Armenia, Aruba, Australia, Austria, Azerbaijan, Bahamas, Bahrain, Bangladesh, Barbados, Belarus, Belgium, Belize, Benin, Bermuda, Bhutan, Bolivia, Botswana, Brazil, Bulgaria, Burundi, Cambodia, Cameroon, Canada, Chad, Chile, China, Colombia, Comoros, Congo, Croatia, Cuba, Cyprus, Denmark, Djibouti, Dominica, Ecuador, Egypt, Eritrea, Estonia, Ethiopia, Fiji, Finland, France, Gabon, Gambia, Georgia, Germany, Ghana, Gibraltar, Greece, Greenland, Grenada, Guadeloupe, Guam, Guatemala, Guernsey, Guinea, Guyana, Haiti, Honduras, Hungary, Iceland, India, Indonesia, Iraq, Ireland, Israel, Italy, Jamaica, Japan, Jersey, Jordan, Kazakhstan, Kenya, Kiribati, Kuwait, Kyrgyzstan, Latvia, Lebanon, Lesotho, Liberia, Libya, Liechtenstein, Lithuania, Luxembourg, Macao, Madagascar, Malawi, Malaysia, Maldives, Mali, Malta, Martinique, Mauritania, Mauritius, Mayotte, Mexico, Monaco, Mongolia, Montenegro, Montserrat, Morocco, Mozambique, Myanmar, Namibia, Nauru, Nepal, Netherlands, Nicaragua, Niger, Nigeria, Niue, Norway, Oman, Pakistan, Palau, Panama, Paraguay, Peru, Philippines, Pitcairn, Poland, Portugal, Qatar, Romania, Rwanda, Samoa, Senegal, Serbia, Seychelles, Singapore, Slovakia, Slovenia, Somalia, Spain, Sudan, Suriname, Swaziland, Sweden, Switzerland, Taiwan, Tajikistan, Thailand, Togo, Tokelau, Tonga, Tunisia, Turkey, Turkmenistan, Tuvalu, Uganda, Ukraine, Uruguay, Uzbekistan, Vanuatu, Venezuela, Yemen, Zambia, Zimbabwe, countries as default };
